import styled from "styled-components";

const CharacterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 40px;
  width: 100%;
  height: 100%;
`;

export default CharacterList;
